import { Col, Container, Row, Spinner } from 'react-bootstrap';
import Layout from '../../Components/Layout/Layout';
import { useState } from 'react';
import ProductDetailsWithModal from './ProductDetailsWithModal';
import { VisitorAuthContext } from '../../Context/AuthContex/VisitorAuthContext';
import CommonProductServiceCard from './CommonProductServiceCard';
import ExhibitorProductSearch from './ExhibitorProductSearch';
import CategorySelectSearchField, {
  ICategory,
} from '../../Components/Common/CategorySelectSearchField';
import {
  ExhibitorList,
  TPublicProductAndServiceList,
} from './apiEndpoints/pubAndSerTypes';
import {
  useAddPubAndServiceWhishList,
  useGetPublicProductAndService,
} from './apiEndpoints/PublicProductServiceEndpoints';
import CommonModal from '../../Components/Common/CommonModal';
import WriteProductComment from './WriteProductComment';
import CommonSearchField from '../../Components/Common/CommonSearchField';
const PublicProductAndServices = () => {
  const { visitorUser } = VisitorAuthContext();
  const [filter, setFilter] = useState<{
    productName: string;
    category_id: string;
    exhibitor: string | number;
  }>({
    productName: '',
    category_id: '',
    exhibitor: '',
  });
  const { mutate, isSuccess, isPending } = useAddPubAndServiceWhishList();
  const { data: PubProductData, isLoading } =
    useGetPublicProductAndService(filter);
  const [commentModal, setCommentModal] = useState<{
    modal: boolean;
    id: number | string;
  }>({ modal: true, id: '' });

  const checkVisitor = (id: number, isFavo: number) => {
    if (!Object?.keys(visitorUser)?.length) {
      // navigate('/visitor-login');
      setCommentModal({ modal: false, id });
    } else {
      mutate({ product_id: id });
      if (!isFavo) {
        setCommentModal({ modal: false, id });
      } else {
        setCommentModal({ modal: true, id });
      }
    }
  };
  const [show, setShow] = useState(false);
  const [data, setData] = useState<TPublicProductAndServiceList>();
  return (
    <Layout pathName={'Product & Services'} showHeader>
      <div>
        <Container className=''>
          <div className='section-title breadcrumb-card'>
            <Row className='align-items-center'>
              <Col xs={12} md={3}>
                {' '}
                <div className='text-start flex-grow-1 w-50 fw-bold justify-content-center'>
                  Filter By
                </div>
              </Col>
              <Col xs={12} md={9}>
                <Row className='g-1'>
                  <Col xs={12} md={4}>
                    <CommonSearchField
                      placeholder='Search by product title'
                      onChange={(value) =>
                        setFilter((prev) => ({ ...prev, productName: value }))
                      }
                    />
                  </Col>
                  <Col xs={12} md={4}>
                    <ExhibitorProductSearch
                      placeholder='exhibitor'
                      onChange={(e: ExhibitorList | null) => {
                        if (e) {
                          setFilter((prev) => ({
                            ...prev,
                            exhibitor: e.user_fair_member_company_name,
                          }));
                        } else {
                          setFilter((prev) => ({
                            ...prev,
                            exhibitor: '',
                          }));
                        }
                      }}
                    />
                  </Col>
                  <Col xs={12} md={4}>
                    <CategorySelectSearchField
                      placeholder='category'
                      onChange={(e: ICategory | null) => {
                        if (e) {
                          setFilter((prev) => ({
                            ...prev,
                            category_id: String(e.id),
                          }));
                        } else {
                          setFilter((prev) => ({
                            ...prev,
                            category_id: '',
                          }));
                        }
                      }}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>

            <div className='w-50 d-flex flex-mo-column justify-content-end'>
              <div className='filter-pasrent'></div>
            </div>
          </div>

          {isLoading ? (
            <div className='text-center'>
              <Spinner
                variant='primary'
                style={{ height: '50px', width: '50px' }}
              />
            </div>
          ) : (
            <>
              <ProductDetailsWithModal
                show={show}
                setShow={setShow}
                data={data}
              />
              <CommonProductServiceCard
                response={PubProductData?.data}
                checkVisitor={(id, isFavo) => {
                  checkVisitor(id, isFavo);
                }}
                getData={(data) => {
                  setShow(!show);
                  setData(data);
                }}
              />
            </>
          )}
        </Container>

        <CommonModal
          modalOff={commentModal?.modal}
          handleCloseFun={() => {
            setCommentModal({ modal: true, id: '' });
          }}
          modalTitle='Add your WishList'
        >
          <WriteProductComment
            handleCloseModal={() => {
              setCommentModal({ modal: true, id: '' });
            }}
            id={Number(commentModal?.id)}
            isLoggedIn={Object?.keys(visitorUser)?.length ? true : false}
          />
        </CommonModal>
      </div>
    </Layout>
  );
};

export default PublicProductAndServices;
